import Baobab from 'baobab';

export default new Baobab({});